module.exports = __webpack_public_path__ + "static/media/email.075c7962.svg";